<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { emitter } from 'shared/helpers/mitt';
import getUuid from 'widget/helpers/uuid';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const { t } = useI18n();
const dialogRef = ref(null);
const id = getUuid();
const card = ref({});

const title = computed(() => {
  if (card.value.name) {
    return t('WGPT_BOARDS.ITEM.LIST.CARD.DELETED.TITLE.WITH_TITLE', {
      cardName: card.value.name,
    });
  }

  return t('WGPT_BOARDS.ITEM.LIST.CARD.DELETED.TITLE.WITHOUT_TITLE');
});

const description = computed(() => {
  if (card.value.name) {
    return t('WGPT_BOARDS.ITEM.LIST.CARD.DELETED.DESC.WITH_TITLE');
  }

  return t('WGPT_BOARDS.ITEM.LIST.CARD.DELETED.DESC.WITHOUT_TITLE');
});

const onShow = () => {
  emitter.emit('WGPT_DROPDOWN_TOGGLE', { id, state: true });
};

const onHide = () => {
  emitter.emit('WGPT_DROPDOWN_TOGGLE', { id, state: false });
};

const open = selectedCard => {
  card.value = selectedCard;
  dialogRef.value?.open();
  onShow();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="title"
    :description="description"
    :show-confirm-button="false"
    :cancel-button-label="t('WGPT_BOARDS.ITEM.LIST.CARD.DELETED.DISMISS')"
    @close="onHide"
  />
</template>
